export * from './src/seating-v1-seating-reservation-seating-reservation.schemas.js';
